import { IPlace } from '../models/place';

const origins: Array<IPlace> = [
  {
    name_en: 'Tokyo Sta.',
    name_ja: '東京駅',
    name_zh_cn: '东京站',
    name_zh_hk: '東京站',
    name_zh_tw: '東京站',
    place_id: 'ChIJC3Cf2PuLGGAROO00ukl8JwA',
    latitude: 35.6811673,
    longitude: 139.7670516,
  },
  {
    name_en: 'Narita Airport',
    name_ja: '成田国際空港',
    name_zh_cn: '成田国际机场',
    name_zh_hk: '成田國際機場',
    name_zh_tw: '成田國際機場',
    place_id: 'ChIJVze90XnzImARoRp3YqEpbtU',
    latitude: 35.7719867,
    longitude: 140.3928501,
  },
  {
    name_en: 'Haneda Airport',
    name_ja: '羽田空港 (東京国際空港)',
    name_zh_cn: '羽田机场（东京国际机场）',
    name_zh_hk: '羽田機場 (東京國際機場)',
    name_zh_tw: '羽田機場 (東京國際機場)',
    place_id: 'ChIJ45IxpAtkGGAR3_hG0anDMg0',
    latitude: 35.5493932,
    longitude: 139.7798386,
  },
  {
    name_en: 'Kansai Airport',
    name_ja: '関西国際空港',
    name_zh_cn: '关西国际机场',
    name_zh_hk: '關西國際機場',
    name_zh_tw: '關西國際機場',
    place_id: 'ChIJ9_rNIxO5AGARiI-QjZ-ncfE',
    latitude: 34.4320024,
    longitude: 135.2303939,
  },
  {
    name_en: 'Chubu Centrair Airport',
    name_ja: '中部国際空港 セントレア',
    name_zh_cn: '中部国际机场 新特丽亚',
    name_zh_hk: '中部國際機場 新特麗亞',
    name_zh_tw: '中部國際機場 新特麗亞',
    place_id: 'ChIJzynM7ZN9BGARJQAsbih9mEI',
    latitude: 34.8590935,
    longitude: 136.8146005,
  },
  {
    name_en: 'New Chitose Airport',
    name_ja: '新千歳空港',
    name_zh_cn: '新千岁机场',
    name_zh_hk: '新千歳機場',
    name_zh_tw: '新千歳機場',
    place_id: 'ChIJ3RpcnUUgdV8R9oH25Xxguho',
    latitude: 42.7925942,
    longitude: 141.6704786,
  },
  {
    name_en: 'Sendai Airport',
    name_ja: '仙台国際空港',
    name_zh_cn: '仙台国际机场',
    name_zh_hk: '仙台國際機場',
    name_zh_tw: '仙台國際機場',
    place_id: 'ChIJ_QgAP08iil8R4Bh_eNoikh4',
    latitude: 38.1397222,
    longitude: 140.9169444,
  },
];

export default origins;
